
interface SearchResultsHeaderProps {
  filteredPropertiesCount: number;
  guests?: string | null;
  checkin?: string | null;
  checkout?: string | null;
}

const SearchResultsHeader = ({ 
  filteredPropertiesCount, 
  guests, 
  checkin, 
  checkout 
}: SearchResultsHeaderProps) => {
  return (
    <div className="mb-12">
      <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
        Resultados de búsqueda
      </h1>
      
      <p className="text-xl text-gray-600">
        {filteredPropertiesCount} propiedades encontradas
        {guests && ` para ${guests} huésped${parseInt(guests) > 1 ? 'es' : ''}`}
        {checkin && checkout && (
          <span>
            {' '}del {checkin} al {checkout}
          </span>
        )}
      </p>
    </div>
  );
};

export default SearchResultsHeader;
